import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const Dot: React.FC<IconSvgProps> = (props) => (
  <svg width="3" height="2" viewBox="0 0 3 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="1.90002" cy="1" r="1" fill={props.color} />
  </svg>
)
